/**
 * Styles for ActionPlan Dashboard
 */

import { StyleSheet, Platform } from 'react-native';
import FontFamily from '../../../constants/fonts';

/**
 * Helper function to get platform-specific shadow styles
 */
export const getCardShadow = () =>
  Platform.select({
    ios: {
      shadowColor: 'rgba(58, 58, 58, 0.08)',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 1,
      shadowRadius: 24,
    },
    android: {
      elevation: 4,
      shadowColor: 'rgba(58, 58, 58, 0.08)',
    },
    web: {
      boxShadow: '0px 4px 24px 0px rgba(58, 58, 58, 0.08)',
    },
  });

export const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#F5F9FF',
  },
  container: {
    flex: 1,
    backgroundColor: '#F5F9FF',
    paddingHorizontal: Platform.OS === 'web' ? '2%' : 16,
  },
  content: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    paddingBottom: 20,
  },
  dashboardHeader: {
    paddingHorizontal: 16,
    paddingVertical: 20,
    backgroundColor: 'transparent',
  },
  dashboardTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: '#3A3A3A',
    marginBottom: 8,
    fontFamily: FontFamily.bold,
  },
  dataTableWrapper: {
    flex: 1,
    backgroundColor: Platform.OS === 'ios' ? '#F5F9FF' : '#ffffff',
    borderRadius: 8,
    marginHorizontal: 0,
    marginBottom: 16,
    ...getCardShadow(),
  },
  messageContainer: {
    padding: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingText: {
    fontSize: 16,
    color: '#005CBC',
    fontFamily: FontFamily.regular,
  },
  retryButton: {
    fontSize: 16,
    color: '#005CBC',
    fontFamily: FontFamily.regular,
    textAlign: 'center',
    marginTop: 16,
    textDecorationLine: 'underline',
  },
  headerBox: {
    backgroundColor: 'transparent',
    marginTop: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  headerBoxMobileSpacing: {
    marginBottom: 0,
  },
  headerTitleContainer: {
    flex: 1,
    paddingRight: 8,
  },
  headerTitle: {
    fontFamily: FontFamily.bold,
    fontWeight: '700',
    fontSize: 24,
    lineHeight: 28,
    color: '#3A3A3A',
    textAlign: 'left',
    marginBottom: 8,
  },
  headerTitleMobile: {
    marginBottom: 10,
  },
  filterContainer: {
    marginTop: 8,
    marginBottom: 16,
    paddingHorizontal: 16,
  },
  mobileFilterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#034895',
    borderColor: '#034895',
    borderRadius: 24,
    paddingHorizontal: 16,
    height: 32,
    width: 120,
    minWidth: 60,
    gap: 4,
    position: 'relative',
    top: -10,
    zIndex: 2,
    justifyContent: 'center',
  },
  mobileFilterButtonText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#FFFFFF',
    lineHeight: 20,
    fontFamily: FontFamily.regular,
  },
  mobileFilterCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    marginVertical: 8,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    overflow: 'hidden',
    marginTop: -52,
  },
  mobileFilterHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: '#FFFFFF',
  },
  mobileFilterHeaderText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#2D2D2D',
    fontFamily: FontFamily.medium,
  },
  mobileFilterArrow: {
    padding: 4,
  },
  mobileFilterContent: {
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
  },
  mobileFilterInner: {
    padding: 16,
  },
});
